/*jshint esversion: 6 */
import { Fancybox } from "@fancyapps/ui";
import './coupon-code-ajax';
import './read-more';
import './variable-product';
import './category-menu';
import './clerk';
import './chat';
import './single-product-gallery';

window.Fancybox = Fancybox;

(function ($) {

	/* Search field on mobile, toggle visibility on mobile */
	const searchField = $('.mobile-header-search input.search-field');
	function toggleSearchField(e) {
		e.preventDefault();
		e.stopPropagation();
		if ( $('body').hasClass('search-open') ) {
			$('body').removeClass('search-open');
			$(searchField).blur();
		} else {
			$('body').addClass('search-open');
			$(searchField).show().focus().select();
		}
	}
	$('a.suki-search-toggle').on('click', toggleSearchField);
	$(searchField).on('focus', function() {
		$('body').addClass('search-focused');
	});
	$(searchField).on('keydown', function() {
		$('body').addClass('search-open');
	});
	$(searchField).on('blur', function() {
		$('body').removeClass('search-focused');
	});
	$('.mobile-header-search .search-overlay').on('click ready', function(e) {
		$('body').removeClass('search-focused').removeClass('search-open');
	});

	/**
	 * Add class to body to indicate when Suki header is sticky or not, in order to position Clerk search results element correctly.
	 * TODO: Find a solution that does not constantly fire when scrolling.
	 */
	const headerElement = document.getElementById('suki-header-main-bar');
	const config = {
		attributes: true,
		attributeFilter: ['class'],
	};
	const callback = function (mutationsList, observer) {
		for (let mutation of mutationsList) {
			if (mutation.target.classList.contains('suki-sticky-in-view')) {
				document.body.classList.add('sticky-header');
			} else {
				document.body.classList.remove('sticky-header');
			}
		}
	};
	const observer = new MutationObserver(callback);
	observer.observe(headerElement, config);

	if ( $('body').hasClass('single-product') ) {

		/* Decide if right column (entry summary) should be sticky or not */
		const checkSingleProductSticky = function() {
			setTimeout( function() {
				const stickyWrapper = document.querySelector('.sticky-wrapper');
				const singleGallery = document.querySelector('.suki-woocommerce-single-gallery');
				const belowSingleGallery = document.querySelector('.below-single-product-gallery');
				const windowHeight = window.innerHeight;
				const leftSideHeight = (singleGallery.offsetHeight + belowSingleGallery.offsetHeight);
				// Only apply if sticky section is lower than left column and window.
				if ( stickyWrapper.offsetHeight < leftSideHeight && stickyWrapper.offsetHeight < windowHeight ) {
					jQuery('.sticky-wrapper').css({
						'position': 'sticky',
						'top': '96px',
					});
				} else {
					jQuery('.sticky-wrapper').css({
						'position': 'relative',
						'top': 'auto',
					});
				}
			}, 500);
		};
		// Check height after elements are ready.
		checkSingleProductSticky();
		// Recheck height on resizing of window.
		window.addEventListener( 'resize', checkSingleProductSticky, false );
		window.addEventListener( 'click', checkSingleProductSticky, false );

		/* Single product page tabs open/close toggle */
		const MIN_TAB_HEIGHT_TOGGLE = 300; // Min content height to toggle
		// Add read-more link
		$('.woocommerce-tabs .tabs .wc-tab').each(function() {
			if ( $(this).innerHeight() < MIN_TAB_HEIGHT_TOGGLE ) {
				$(this).addClass('active no-toggle');
				$(this).prev('.tab').addClass('active no-toggle');
			} else {
				$(this).addClass('toggle');
				$('<a class="tab-toggle" href="#' + $(this).attr('ID') + '">Les mer</a>').insertAfter($(this));
			}
		});
		// Add read-more toggle functionality
		$('.woocommerce-tabs .tabs .tab a, .woocommerce-tabs .wc-tab + a.tab-toggle').on( 'click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var tabID = $(this).attr('href');
			var tabContent = $(tabID);
			var tab = $(tabContent).prev('.tab');
			if ( ! $(tab).hasClass('active') ) {
				$(tab).addClass('active');
				$(tabContent).addClass('active');
				$(tabContent).next('a.tab-toggle').text('Vis mindre');
			} else {
				$(tab).removeClass('active');
				$(tabContent).removeClass('active');
				$(tabContent).next('a.tab-toggle').text('Vis mer');
			}
		});

	}

	/* Show/hide login on cart page */
	$('body.woocommerce-cart a.showlogin').on( 'click', function(e) {
		e.preventDefault();
		$( 'form.login, form.woocommerce-form--login' ).slideToggle();
	});

	/* Handle add-to-cart Ajax notification */
	var prodTitle = $('h1.product_title').text();
	var timer = null;
	$(document.body).on('added_to_cart', function( event, fragments, cart_hash, button ) {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}
		if ( $(button).hasClass('single_add_to_cart_button') ) { // If main product add-button, open sidebar cart.
			$('body').removeClass('cart-add');
			$('.drawer-shopping-cart-title').text( prodTitle + ' ble lagt til i handlekurven' );
			return;
		} else { // If quick add button show dismissable notification box for 5 seconds.
			$('body').addClass('cart-add');
			if ( $(button).closest($('#off-canvas-cart')).length < 1 ) {
				$('body').removeClass('suki-has-popup-active');
				$('#off-canvas-cart').hide();
				setTimeout(function() {
					$('body').removeClass('suki-has-popup-active');
					$('#off-canvas-cart').removeClass('suki-popup-active').show();
				}, 750);
			}
			$('.added-to-cart .product-name').text( button.data('product_name') );
			$('.drawer-shopping-cart-title').text( prodTitle + ' ble lagt til i handlekurven' );
			timer = setTimeout(function() {
				$('body').removeClass('cart-add');
			}, 5000);
		}
	});
	$('.close-popup').on( 'click', function(e) {
		e.preventDefault();
		$('body').removeClass('cart-add');
	});

})(jQuery);
